<template>
  <div>
    <custom-tooltip :content="`Turn ${ notificationEnabled ? 'off' : 'on' } alerts`">
      <div :class="['alerts', { notificationEnabled }]" slot="buttonContent">
        <img :src="notificationIcon" alt="" />
      </div>
    </custom-tooltip>
  </div>
</template>

<script>
import CustomTooltip from '@/components/common/CustomTooltip.vue';
import notificationEnabledIcon from '@/assets/icons/bell_icn@1x.svg';
import notificationDisabledIcon from '@/assets/icons/bell_icn_2@1x.svg';

export default {
  name: 'AlertTableCell',
  components: {
    CustomTooltip,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
  computed: {
    notificationIcon() {
      return this.notificationEnabled ? notificationEnabledIcon : notificationDisabledIcon;
    },
    notificationEnabled() {
      return false;
    },
  },
};
</script>

<style scoped>
.alerts {
  align-items: center;
  background-color: #e8ecf0;
  border-radius: 2px;
  cursor: pointer;
  display: flex;
  height: 28px;
  justify-content: center;
  width: 28px;
}
.notificationEnabled {
 background-color: #fef5dd;
}
</style>
